import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class SheduleService {

  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }


  public registerDate(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getStatusSecciones(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getBanderas(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getBaderasEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getBanderas_req(idEmpresa,data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getBaderasEncuesta+idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public setBandera_req(idEmpresa,data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.setBaderasEncuesta+idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public sendSurvey(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postCrearEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/crearEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerRecordatorio(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerCierre(data){

return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getFechaLanzamiento(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/fechaLanzamiento/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getRecordatorios(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getRecordatorios+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/recordatorios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public crearEncuesta(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postCrearEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/crearEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveUsuarios(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveUsuarios+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveUsuarios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public applyUsuarios(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.applyUsuarios+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/applyUsuarios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveNPS(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveNPS+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveNPS/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveReactivos(data){
    console.log('Enviando peticion /api_empresa/saveReactivos/');
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveReactivos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveReactivos/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveControl(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveControl+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveControl/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveDemograficos(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveDemograficos+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveDemograficos/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveAdicionales(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAdicionales+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveAdicionales/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveAbiertas(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAbiertas+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveAdicionales/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public saveForall(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveForall+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveForall/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getEstatusEncuesta(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getEstatusEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getEstatusEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  public guardaLinkEncuesta(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.guardarLinkEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getEstatusEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  public getEncuestaEstatus(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getEstatusBanderaEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getEstatusEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


}
